<template>
  <div>
    <link
      href="https://img2.233.com/wx/union/pc/fine/category/css/zjxfy.css"
      rel="stylesheet"
      type="text/css"
    />
    <div class="wx-header-cont" id="wx-header-cont">
      <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
      <div class="wx-header-container">
        <div class="fl-box">
          <h1 class="logo">
            <a href="/"><img :src="logo" /> </a>
          </h1>
          <div class="line"></div>
          <div class="wx-subject">
            <h2>消防设施操作员</h2>
            <i class="dropdown-arrow"></i>
            <div class="subject-list">
              <a href="./#/jianli">监理工程师</a>
              <a href="./#/aq">安全工程师</a>
              <a href="./#/cfe">一级消防工程师</a>
              <a href="./#/zaojia">造价工程师</a>
              <a href="./#/jzs1">一级建造师</a>
              <a href="./#/jzs2">二级建造师</a>
              <a href="./#/zjy">二级造价工程师</a>
              <a href="./#/zjxfy">消防设施操作员</a>
            </div>
          </div>
          <div
            class="head-area  text-gry6 font14 fl m-t-10"
            style="display: none;"
          >
            当前地区
            <p class="m-l-15  bg-white fr ">
              <em class="now-area p-0-20">全国版</em
              ><a href="" class="more-area p-0-10">更多地区 </a>
            </p>
            <div class="area_list">
              <ul>
                <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                <li><a href="/tegang/henan/">河南</a></li>
                <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="fr-box">
          <!--未登录 -->
          <div class="personal-no" v-if="!isLogin">
            <p>
              <a
                target="_blank"
                :href="'/uc/login?redirecturl=' + href"
                class="red"
                >登录</a
              >|<a target="_blank" :href="'/uc/register?redirecturl=' + href"
                >注册</a
              >
            </p>
          </div>
          <div class="personal" v-else>
            <a href="javascript:;" class="pic"
              ><img :src="logoSrc"/><i class="dropdown-arrow"></i
            ></a>
            <div class="pop-personal">
              <a href="javascript:" @click="loginout()"
                ><i class="icon"></i><span class="txt">退出</span></a
              >
            </div>
          </div>
          <div class="classify">
            <a
              class="classify-list"
              href="/shopping/cart"
              target="_blank"
              title="购课车"
            >
              <p class="icon shopping"></p>
            </a>
          </div>
          <div v-if="kefu.length > 0" class="wx-telephone">
            <p class="txt1">客服热线</p>
            <p class="txt2">{{ kefu }}</p>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!--banner-->
    <div class="bg-black">
      <!--01banner-->
      <Banner imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/zjxfy/banner01.jpg"></Banner>
      <!--01banner 结束-->
      <!---02试听区域--->
      <div class="video clearfix">
        <div class="video-layout">
          <div class="subject-tabBox clearfix">
            <ul class="sub-tabL clearfix">
              <li
                class="line"
                @click="changeCourseIndex(i)"
                v-for="(v, i) in courses.slice(0, 4)"
                :key="i"
              >
                <a
                  href="javascript: void(0)"
                  :class="i == courseIndex ? 'hover' : ''"
                  >{{ v.name }}</a
                >
              </li>
            </ul>
            <div
              class="Rselect-box"
              @mouseover="changeIsHoverCourse(true)"
              @mouseout="changeIsHoverCourse(false)"
            ></div>
          </div>
          <myvideo
            :isLogin="isLogin"
            :allLoginPlayFlag="allLoginPlayFlag"
            :unionId="unionId"
            :classEname="'zjxfy'"
            :logo="logo"
            :myClassId="courses[courseIndex].myClassId"
          ></myvideo>
        </div>
        <div class="video-bottom"></div>
      </div>
      <!---02试听区域END--->
    </div>
    <!--03原高级平台班级对比-->
    <banjiduibi
      :calssName="'消防设施操作员'"
      :classEName="'zjxfy'"
    ></banjiduibi>
    <!--03原高级平台班级对比 end-->

    <!--04全部班级表格-->
    <quanbubanji :classEname="'zjxfy'"></quanbubanji>
    <!--04全部班级表格 end-->
    <!--06套用官网内容  开始------------->
    <!-- 师资团队 -->
    <div class="z-teacher">
      <div class="z-teacherbox">
        <div class="wx-title-box pt50">
          <h2 class="wx-title wx-titlethree">
            <p class="txt1">师资团队</p>
            <p class="txt2">名师助学，更快突破及格线</p>
          </h2>
        </div>
        <div
          class="careerbox"
          data-type="{'cs1':'current','tlist':'li','ev':'click'}"
          node-type="menu-mouse"
        >
          <ul class="g-clr ">
            <li
              :class="teacherIndex == 0 ? 'mg current' : 'mg'"
              @mouseover="changeTeacherIndex(0)"
            >
              <span class="switch-bg"
                ><a
                  ><span>程一波<b>CHENG YI BO</b></span>
                  <p><i></i>多年消防教学经验</p></a
                ></span
              >
              <div class="career_bg">
                <div class="malebg"></div>
                <div class="femalebg">
                  <img
                    class="lazy"
                    width="290"
                    height="423"
                    src="https://img2.233.com/wx/union/pc/fine/category/img/zjxfy/guowei.png"
                    style="display: block"
                  />
                </div>
                <div class="career_detail">
                  <div class="detail-img">
                    <h6>程一波</h6>
                    <span class="sexswitch"></span>
                    <p>智慧型美女老师</p>
                  </div>
                  <div class="more-button">
                    <dt>
                      <em>主讲内容</em
                      ><span>《消防设施操作员（基础知识）》</span>
                    </dt>
                    <dt>
                      <em>专业资历</em
                      ><span>注册一级消防工程师、注册资产评估师。</span>
                    </dt>
                    <dt>
                      <em>学员评价</em
                      ><span
                        >程老师责任心特强，讲课思路清晰，知识点汇总全面，学习方法特别实用，智慧型美女老师。</span
                      >
                    </dt>
                  </div>
                </div>
              </div>
            </li>
            <li
              :class="teacherIndex == 1 ? 'mj current' : 'mj'"
              @mouseover="changeTeacherIndex(1)"
            >
              <span class="switch-bg"
                ><a
                  ><span>胡 云<b>HU YUN</b></span>
                  <p><i></i>10年建筑类教学经验<br />&nbsp;5年消防教学经验</p></a
                ></span
              >
              <div class="career_bg">
                <div class="malebg"></div>
                <div class="femalebg">
                  <img
                    class="lazy"
                    width="295"
                    height="424"
                    src="https://img2.233.com/wx/union/pc/fine/category/img/zjxfy/wuxinhua.png"
                    style="display: block"
                  />
                </div>
                <div class="career_detail">
                  <div class="detail-img">
                    <h6>胡云</h6>
                    <span class="sexswitch"></span>
                    <p>高人气讲师</p>
                  </div>
                  <div class="more-button">
                    <dt>
                      <em>主讲课程</em><span>《消防设施操作员（中级）》</span>
                    </dt>
                    <dt>
                      <em>专业资历</em
                      ><span>高级工程师，一级消防工程师，一级建造师</span>
                    </dt>
                    <dt>
                      <em>学员评价</em
                      ><span
                        >胡老师的课程相当好，授课严谨，主次分明，注重分析，零基础学员听了也很透彻。</span
                      >
                    </dt>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 师资团队 end-->
    <!-- 课程介绍 -->
    <div class="z-value">
      <div class="z-main">
        <div class="wx-title-box mt50">
          <h2 class="wx-title wx-titleone">
            <p class="txt1">课程<strong>介绍</strong></p>
            <p class="txt2">抓理论、重实操，拿证更简单</p>
          </h2>
        </div>
        <div class="kcjs_all">
          <ul class="kcjs_ul1 clearfix">
            <li class="kcjs_md kcjs_md_1">
              <div class="kc_md1_title"><h4>精讲班</h4></div>
              <div class="js_md_txt clearfix">
                <ul class="js_txt_ul clearfix">
                  <li class="line_right">
                    <span><i class="red_btext">基础</i>知识</span>
                    <p>
                      根据考试要求，将理论基础内容按照章节进行强化巩固，掌握理论考试重点，同时为实操课程学习打下坚实基础。
                    </p>
                  </li>
                  <li class=" ">
                    <span><i class="red_btext">中级</i>技能</span>
                    <p>
                      主要讲解消防巡查，消防联动控制等关于技术设备类操作相关知识，帮助认知实际工作内容。
                    </p>
                  </li>
                </ul>
              </div>
            </li>
            <li class="kcjs_md kcjs_md2">
              <div class=" kc_md2_title"><h4>实操班</h4></div>
              <p>
                老师现场实操同时讲解流程，更直观体现技能操作要点细节，帮助非专业考生强化实操弱项。
              </p>
            </li>
            <li class="kcjs_md kcjs_md3">
              <div class=" kc_md2_title"><h4>习题班</h4></div>
              <p>
                对当年的考试真题进行详细讲解，并结合课程预测下次考试趋势及方向。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 课程介绍 end-->
    <div class="sf-box clearfix">
      <!--你的收获-->
      <div class="wx-title-box mt50">
        <h2 class="wx-title wx-titletwo">
          <p class="txt1">你的<strong>收获</strong></p>
          <p class="txt2">选择233网校，让你付出和收获成正比</p>
        </h2>
      </div>
      <div class="sf-box-content clearfix">
        <ul class="hd-xxm clearfix">
          <li class="cont">
            <i class="icon1 mt"></i><i class="icon2"></i>
            <p class="txt1">
              <strong>1</strong><span>小<br />时</span>
            </p>
            <p class="txt2 w1">
              课程知识点讲解细化，<strong>每天学习1小时</strong>，拿下证书持证上岗
            </p>
          </li>
          <li class="line"></li>
          <li class="cont">
            <i class="icon1 zw"></i><i class="icon2"></i>
            <p class="txt1">
              <strong>90<s>%</s></strong
              ><span>考<br />点</span>
            </p>
            <p class="txt2">
              程一波、胡云等消防界大咖授课掌握<strong>90%+考点</strong>
            </p>
          </li>
          <li class="line"></li>
          <li class="cont w3">
            <i class="icon1 ss"></i><i class="icon2"></i>
            <p class="txt1"><strong>50</strong><span>%</span></p>
            <p class="txt2 w2">
              约50小时全面掌握基础知识及实操技能，<strong>比自学省时50%</strong>
            </p>
          </li>
        </ul>
        <div class="bd-xxm">
          <div class="txt-box">
            <p class="txt1">40+万人都在报名考的证书</p>
            <p class="txt2">越早考下越早上岗</p>
          </div>
          <a href="javascript:" @click="scroll(900)" class="btn-xxm"
            >立即报名</a
          >
        </div>
        <div class="pic"></div>
      </div>
      <!--你的收获 end--><!--证书价值-->
      <div class="wx-title-box mt110">
        <h2 class="wx-title wx-titleone">
          <p class="txt1">证书<strong>价值</strong></p>
          <p class="txt2">上岗硬条件，入门必备</p>
        </h2>
      </div>
      <div class="zsjz-content-box clearfix">
        <ul class="clearfix">
          <li class="zczc">
            <p class="txt1">政策支持，前景可观<i></i></p>
            <p class="txt2">
              国家政策支持，2020年1月1日起施行《消防设施操作员国家职业技能标准》，考取中级可获得1500元补贴。
            </p>
          </li>
          <li class="scxq">
            <p class="txt1">市场需求高，人才稀缺<i></i></p>
            <p class="txt2">
              从事消防设备维护保养检测服务的消防技术服务机构，要求取得消防设施操作员，不少于6人；每栋楼消防监控室需2名持证人员。
            </p>
          </li>
          <li class="zyfx">
            <p class="txt1">一本证书多个职业方向<i></i></p>
            <p class="txt2">
              消防安全检查、消防控制室监控、消防设施操作与维护、消防安全管理与培训、消防组长、消防主管。
            </p>
          </li>
          <li class="czsg">
            <p class="txt1">持证上岗，待遇丰厚<i></i></p>
            <p class="txt2">
              证书全国终身有效，无需继续教育，属于准入类证书，需要持证上岗，考证相当于考饭碗，目前市场上相关职业招聘工资6千-1万/月。
            </p>
          </li>
        </ul>
      </div>
      <!--证书价值 end--><!--证书需求 -->
      <div class="wx-title-box mt110">
        <h2 class="wx-title wx-titleone">
          <p class="txt1">证书<strong>需求</strong></p>
          <p class="txt2">哪些人适合考这个证书</p>
        </h2>
        <div>
          <div class="zsxq-content-box clearfix">
            <ul>
              <li class="one">
                <span class="icon"></span>
                <div class="pic">
                  <img
                    src="https://img2.233.com/wx/union/pc/fine/category/img/zjxfy/zsxq_pic1.jpg"
                  />
                </div>
                <p class="txt1">物业公司从业者<i></i></p>
                <p class="txt2">
                  住宅小区、写字楼等日益复杂的物业工作内容，岗位要求专业提升
                </p>
              </li>
              <li class="two">
                <span class="icon"></span>
                <div class="pic">
                  <img
                    src="https://img2.233.com/wx/union/pc/fine/category/img/zjxfy/zsxq_pic2.jpg"
                  />
                </div>
                <p class="txt1">安保人员<i></i></p>
                <p class="txt2">
                  随着人们对安全的要求提高，对消防工作的重视，安保消防持证上岗成为趋势
                </p>
              </li>
              <li class="three">
                <span class="icon"></span>
                <div class="pic">
                  <img
                    src="https://img2.233.com/wx/union/pc/fine/category/img/zjxfy/zsxq_pic3.jpg"
                  />
                </div>
                <p class="txt1">消防公司从业者<i></i></p>
                <p class="txt2">
                  各大消防公司加强业务培训，确保相关人员熟练掌握和运用，要求考取相关证书
                </p>
              </li>
              <li class="four">
                <span class="icon"></span>
                <div class="pic">
                  <img
                    src="https://img2.233.com/wx/union/pc/fine/category/img/zjxfy/zsxq_pic4.jpg"
                  />
                </div>
                <p class="txt1">其他人员<i></i></p>
                <p class="txt2">
                  日常生活工作中，对防火救援等消防安全知识缺乏的大众，主动了解，防患未然
                </p>
              </li>
            </ul>
          </div>
          <!--证书价值 end-->
        </div>
      </div>
      <!--证书需求 END-->
    </div>

    <!--06套用官网内容  end------------->
    <!--05服务特色标题-->
    <div class="main-title f-tac m-b-30 p-t-50">
      <p class="font-bg">CHARACTERISTIC</p>
      <h2 class="font44 fb">选择我们的<em class="text-red fb">四大理由</em></h2>
      <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
    </div>
    <div class="fuwu-bg ">
      <div class="fuwu-content">
        <div class="fuwu-box">
          <ul class="clearfix m-b-20">
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">1</span>课程品质高
              </h4>
              <p class="font15 lh2 p-15">
                课程专业的教研团队精心打造，<em class="text-red fb"
                  >每个课程均经过20+次以上迭代</em
                >。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">2</span>老师实力强
              </h4>
              <p class="font15 lh2 p-15">
                网校执行严格的<em class="text-red fb"
                  >师资淘汰制，由购课学员评分</em
                >，努力建设零差评老师团队。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">3</span>学习服务优
              </h4>
              <p class="font15 lh2 p-15">
                您在学习课程中遇到任何问题，可在线提问，专业老师<em
                  class="text-red fb"
                  >24小时内为您答疑解惑</em
                >。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">4</span>售后服务好
              </h4>
              <p class="font15 lh2 p-15">
                部分套餐课程享<em class="text-red fb">超长有效期</em
                >，课程有效期内考试<em class="text-red fb">不过免费重学</em
                >保障。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--05服务特色 end-->
  </div>
</template>
<script>
import myvideo from "@/components/myvideo";
import banjiduibi from "@/components/banjiduibi";
import quanbubanji from "@/components/quanbubanji";
import { getMemberPicpath } from "@/request/request.js";
export default {
  name: "App",
  components: {
    banjiduibi,
    quanbubanji,
    myvideo,
  },
  data() {
    return {
      laoshiindex: 0,
      isLogin: false,
      logoSrc: "",
      allLoginPlayFlag: false,
      unionId: "",
      kefu: "",
      logo: "",
      href: "",
      courses: [
        { name: "基础知识", myClassId: 32122 },
        { name: "中级技能", myClassId: 32123 },
      ],
      courseIndex: 0,
      isHoverCourse: false,
      teacherIndex: 0,
      kdIndex: 0,
    };
  },
  created() {
    this.href = encodeURIComponent(window.location.href);
    var config = JSON.parse(
      sessionStorage.getItem(window.location.host + "puconfig")
    );
    if (config.KefuTelList.length > 0) {
      this.kefu = config.KefuTelList[0].KefuNumber;
    }
    this.unionId = config.UnionId;
    this.logo = config.UnionLogo;
    this.allLoginPlayFlag = config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if (token != undefined) {
      this.isLogin = true;
      getMemberPicpath({}, (res) => {
        this.logoSrc = res;
      });
    } else {
      var interval = setInterval(() => {
        token = localStorage.getItem("usertoken");
        if (token != undefined) {
          this.isLogin = true;
          getMemberPicpath({}, (res) => {
            this.logoSrc = res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods: {
    loginout() {
      this.isLogin = false;
      this.logoSrc = "";
      localStorage.removeItem("usertoken");
    },
    scroll(num) {
      document.documentElement.scrollTop = num;
    },
    changeCourseIndex(i) {
      this.courseIndex = i;
    },
    changeIsHoverCourse(flag) {
      this.isHoverCourse = flag;
    },
    changehoverindex(i) {
      this.hoverindex = i;
    },
    changeTeacherIndex(i) {
      this.teacherIndex = i;
    },
    changeKdIndex(i) {
      this.kdIndex = i;
    },
  },
};
</script>
